<template>
  <div class="giveaway" v-if="giftList.length">
    <!-- 多个赠品 -->
    <v-list-view
      name="赠品"
      @click="handlePopShow"
      :class="['g-container', { 'optional-list': optionalList.length }]"
      right-icon="arrow-right-v3"
      v-track="[
        {
          act: 'show',
          params: {
            cfrom: '159|002|02|077',
            event_id: '159|002|02|077',
            page_name: 1,
            sku_id: skuId,
            isno_choose: optionGifts.length ? 1 : 0
          }
        },
        {
          act: 'click',
          params: {
            cfrom: '159|002|01|077',
            event_id: '159|002|01|077',
            page_name: 1,
            sku_id: skuId,
            isno_choose: optionGifts.length ? 1 : 0
          }
        }
      ]"
    >
      <div class="g-content">
        <div class="g-list">
          <v-scroll-x :data="curGiftList">
            <template v-slot="{ data: item }">
              <div
                :class="[
                  item.optionalGiftId ? 'giveaway-optional' : 'giveaway-item',
                  {
                    'single-item': curGiftList.length == 1 && item.giftFlag == 1 && !item.optionalGiftId
                  },
                  {
                    'border-pt': item.vipGiftLevel === 1,
                    'border-by': item.vipGiftLevel === 2,
                    'border-hj': item.vipGiftLevel === 3,
                    'border-zs': item.vipGiftLevel === 4,
                    'border-zd': item.giftType == 43
                  },
                  'border1px',
                  { gray: item.giftType == 43 && !item.hourGiftFlag }
                ]"
              >
                <div class="optional-gifts" v-if="item.optionalGiftId">
                  <div class="optional-num g-top">
                    <div class="num-bg"></div>
                    <p>可{{ optionGifts.length | formatCaseNum }}选{{ optionalGiftNum | formatCaseNum }}</p>
                  </div>
                  <div class="optional-item" v-for="(oItem, oIndex) in optionGifts" :key="oIndex">
                    <img :src="oItem.smallPic" alt class="g-img" />
                    <div class="g-name">{{ oItem.shortName || oItem.name }}</div>
                  </div>
                </div>
                <template v-if="!item.optionalGiftId">
                  <img :src="item.smallPic" alt class="g-img" />
                  <!-- 整点加赠 -->
                  <div class="g-top count-down" v-if="item.giftType == 43">
                    <div class="zd-bg"></div>
                    <!-- 进行中展示剩余倒计时，未开始隐藏倒计时，待start后刷新 -->
                    <div
                      class="count-time"
                      v-if="currentTime"
                      :aria-label="
                        ariaformate(
                          item.hourGiftFlag == 1,
                          item.hourGiftStartTime,
                          currentTime,
                          item.hourGiftEndTime * 1
                        )
                      "
                    >
                      <v-count-down
                        :start="item.hourGiftStartTime"
                        :current="currentTime"
                        :end="item.hourGiftEndTime * 1"
                        :endFun="refreshCurGiftList"
                        :startFun="refreshCurGiftList"
                        hiddenHour
                        v-show="item.hourGiftFlag == 1"
                      ></v-count-down>
                      <!-- 未开始 -->
                      <p v-if="item.hourGiftFlag != 1">整点加赠</p>
                    </div>
                  </div>
                  <!-- 会员加赠 -->
                  <template v-else-if="item.giftType == 42">
                    <div class="g-top g-vip-pt" v-if="item.vipGiftLevel == 1">
                      <p>会员专享</p>
                    </div>
                    <div class="g-top g-vip-by" v-if="item.vipGiftLevel == 2">
                      <p>白银专享</p>
                    </div>
                    <div class="g-top g-vip-hj" v-else-if="item.vipGiftLevel == 3">
                      <p>黄金专享</p>
                    </div>
                    <div class="g-top g-vip-zs" v-else-if="item.vipGiftLevel == 4">
                      <p>钻石专享</p>
                    </div>
                  </template>
                  <div class="single-info" v-if="curGiftList.length == 1 && item.giftFlag == 1 && !item.optionalGiftId">
                    <div class="s-price">
                      <span class="sale-price">￥0</span>
                      <span class="market-price" v-if="item.marketPrice" :aria-label="`原价￥${item.marketPrice}`">
                        ￥{{ item.marketPrice }}
                      </span>
                    </div>
                    <div class="s-name">{{ item.shortName || item.name }}</div>
                  </div>
                  <div class="g-name" v-else>{{ item.shortName || item.name }}</div>
                </template>
              </div>
            </template>
          </v-scroll-x>
        </div>
        <div class="g-choose" v-if="optionalList.length">挑选</div>
      </div>
    </v-list-view>

    <v-os-popup
      v-model="isShowPop"
      title="赠品"
      :footerText="buttonNameChange"
      @footerClick="handleClose"
      @close="handleClose"
      :footerShow="isFooterShow"
      container="body"
    >
      <p class="tip">数量有限，赠完即止</p>
      <div class="g-pop-box">
        <!--正在进行中整点加赠 -->
        <OnTheHour :timeGift="hourGiftsIng" class="g-pop-item" v-if="hourGiftsIng.length" />
        <div class="optional-gifts-module">
          <OptionalGifts
            v-for="item in optionalList"
            :key="item.optionalGiftId"
            :list="item.list"
            :optionalGiftId="item.optionalGiftId"
            :selectNums="item.selectNums"
            :skuId="skuId"
            @select="handleGiftSelect"
          ></OptionalGifts>
        </div>
        <div class="normal-gifts-module" v-if="normalGifts && normalGifts.length">
          <div v-for="(item, index) in normalGifts" :key="index" class="g-pop-item">
            <giveaway-pop-item :giftItem="item" class="g-pop-item" :positionKey="index"></giveaway-pop-item>
          </div>
        </div>
        <!--下一场未开始整点加赠预告，没有正在进行中的才展示，否则隐藏，待到开始时间再刷新 -->
        <OnTheHour :timeGift="hourGiftsNext" class="g-pop-item" v-if="hourGiftsIng.length == 0" />
      </div>
    </v-os-popup>
  </div>
</template>

<script>
import OnTheHour from './on-the-hour'
import GiveawayPopItem from './giveaway-pop-item'
import OptionalGifts from './optional-gifts'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import interval from 'utils/interval'
/*
    数字转中文(只支持一百以内的)
    @number {Integer} 形如23的数字
    @return {String} 返回转换成的形如 二十三 的字符串
*/
function numberToChinese(number) {
  const chars = '零一二三四五六七八九'
  const a = (number + '').split('')
  const s = []
  if (a.length === 1) {
    return chars.charAt(a[0])
  } else if (a.length === 2) {
    a.forEach((el, index) => {
      s.push(chars.charAt(el))
      if (index !== 1) {
        s.push('十')
      }
    })
    if (s[0] === '一') {
      s.shift()
    }
    if (s[s.length - 1] === '零') {
      s.pop()
    }
    return s.toString().replaceAll(',', '')
  } else {
    return ''
  }
}
export default {
  name: 'Giveaway',
  components: {
    OnTheHour,
    GiveawayPopItem,
    OptionalGifts
  },
  data() {
    return {
      giftList: [],
      isShowPop: false,
      hourGiftsIng: [], // 整点加赠正在进行中
      hourGiftsNext: [], // 整点加赠未开始第一场
      normalGifts: [], // 普通赠品
      optionGifts: [], // 可选赠品
      initFlag: true, // 初始化勾选的赠品数据
      tempTime: '' // 当前时间，定时刷新
    }
  },
  filters: {
    formatCaseNum(val) {
      if (val) {
        return numberToChinese(val)
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapState('detailv3', ['spuInfo', 'skuInfo', 'selectedGifts']),
    ...mapGetters('detailv3', ['skuId', 'commodityGifts']),
    // 服务器当前时间
    currentTime: {
      get: function () {
        if (this.tempTime) {
          return this.tempTime
        } else {
          return this.spuInfo?.configInfoVo?.currentTime || ''
        }
      },
      set: function (val) {
        this.tempTime = val
      }
    },
    // 当前有效赠品列表,有正在进行中整点加赠，不展示未开始；无正在进行中整点加赠，展示未开始第一场
    curGiftList() {
      let curGifts = []
      let list = this.optionGifts.slice(0, 1).concat(this.normalGifts)
      if (this.hourGiftsIng.length > 0) {
        curGifts = this.hourGiftsIng.concat(list)
      } else {
        curGifts = list.concat(this.hourGiftsNext)
      }
      return curGifts
    },
    // 可选活动列表
    optionalList() {
      return this.optionGiftsChange(this.optionGifts)
    },
    // 可选赠品数量
    optionalGiftNum() {
      let num = 0
      this.optionalList.forEach(el => {
        num += el.selectNums
      })
      return num
    },
    buttonNameChange() {
      return this.optionGifts?.length ? '确定' : '关闭'
    },
    isFooterShow() {
      return !!this.optionGifts?.length
    }
  },
  watch: {
    commodityGifts: {
      handler(newObj) {
        this.giftList = newObj
        // giftType 赠品活动类型：41：常规赠品 42：会员加赠 43：整点加赠 44：仅赠券
        // giftFlag	赠品标识：1-实物 2-优惠券 3-加赠积分 4-虚拟赠品 5-多倍积分
        // giftCouponType 优惠券显示类型：1-代金券 2-免邮券 3-优惠券
        // vipGiftLevel 会员等级 1：普通 2：白银 3：黄金 4:钻石
        if (this.giftList.length) {
          // skuInfo信息刷新会触发几次，清空重置
          this.normalGifts = []
          this.optionGifts = []
          // 非整点加赠的普通赠品
          this.giftList.forEach((item, index) => {
            if (item.giftType != 43 && !item.optionalGiftId) {
              this.normalGifts.push(Object.assign({}, item))
            }
            if (item.optionalGiftId) {
              this.optionGifts.push(Object.assign({}, item))
            }
          })
        }
        this.initFlag = true
      },
      deep: true,
      immediate: true
    },
    giftList: {
      // 监听赠品列表变化，重置列表
      handler(nList, oList) {
        if (nList) {
          this.refreshCurGiftList()
          // 切换skuId时，初始化勾选的赠品数据
          if (this.initFlag) {
            this.initOptionGift()
          }
        }
      },
      deep: true,
      immediate: true
    },
    optionGifts: {
      handler() {
        this.updateGiftId()
      },
      deep: true
    }
  },
  mounted() {
    //
  },
  methods: {
    ...mapMutations('detailv3', [
      'UPDATE_GIFT_ID',
      'UPDATE_GIFT_OPT',
      'UPDATE_SELECTED_GIFT_IDS',
      'UPDATE_LAST_CHOOSED_GIFT_IDS'
    ]),
    ...mapActions('detailv3', ['savePreFocusElByEvent']),
    ariaformate(flag, startTime, currentTime, endTime) {
      if (flag) {
        if (startTime > currentTime) {
          let time = startTime - currentTime
          let h = parseInt(time / 3600000) % 24
          let m = parseInt(time / 60000) % 60
          return `整点加赠将于${h}小时${m}分钟后开始`
        } else if (endTime > currentTime) {
          let time = endTime - currentTime
          let h = parseInt(time / 3600000) % 24
          let m = parseInt(time / 60000) % 60
          return `整点加赠将于${h}小时${m}分钟后结束`
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    // 刷新整点加赠列表,进行中与未开始的第一场，未开始第二场等待区，待刷新后补位未开始第一场
    refreshCurGiftList() {
      this.hourGiftsIng = []
      this.hourGiftsNext = []
      // 刷新当前时间
      if (interval.hasInited) {
        this.currentTime = interval.time
      }
      // giftList为原始返回数据，属性不变，仅重置正在进行中与下一场数据，同一状态可能有多条数据
      this.giftList.forEach((item, index) => {
        if (item.giftType == 43) {
          // 进行中赠品列表
          if (this.currentTime >= item.hourGiftStartTime && this.currentTime < item.hourGiftEndTime) {
            let tempIng = Object.assign({}, item)
            tempIng.hourGiftFlag = 1
            tempIng.giftNowTime = this.currentTime
            this.hourGiftsIng.push(tempIng)
          }
          // 第一场未开始
          if (this.currentTime < item.hourGiftStartTime) {
            if (
              this.hourGiftsNext.length == 0 ||
              (this.hourGiftsNext.length && item.hourGiftFlag == this.hourGiftsNext[0].hourGiftFlag)
            ) {
              let tempIng = Object.assign({}, item)
              tempIng.giftNowTime = this.currentTime
              this.hourGiftsNext.push(tempIng)
            }
          }
        }
      })
      this.$forceUpdate()
    },
    initOptionGift() {
      let index = this.selectedGifts.findIndex(item => item.skuId == this.skuId)
      if (index > -1) {
        this.optionGifts.forEach(item => {
          let giftId = item.optionalGiftId + item.id
          if (this.selectedGifts[index].giftsList.includes(giftId)) {
            item.canOptional = 1
          } else {
            item.canOptional = 0
          }
        })
      }
    },
    optionGiftsChange(list) {
      let arr = [...new Set(list.map(v => v.optionalGiftId))]
      let options = []
      arr.forEach(item => {
        let obj = {}
        obj.optionalGiftId = item
        obj.list = list.filter(v => v.optionalGiftId == item)
        obj.selectNums = obj.list[0].allOpCount
        options.push(obj)
      })
      return options
    },
    handleGiftSelect(optionalGiftId, selectIdList) {
      this.optionalList
        .find(item => item.optionalGiftId == optionalGiftId)
        .list.forEach(item => {
          if (selectIdList.includes(item.id)) {
            item.canOptional = 1
          } else {
            item.canOptional = 0
          }
        })
    },
    updateGiftId() {
      if (this.optionalList.length) {
        let giftIds = []
        this.optionalList.forEach(item => {
          let arr = item.list.filter(v => v.canOptional == 1).map(v => item.optionalGiftId + v.id)
          giftIds = giftIds.concat(arr.length ? arr : [item.optionalGiftId + 'none'])
        })
        this.UPDATE_GIFT_ID(giftIds.join(','))
      } else {
        this.UPDATE_GIFT_ID('')
      }
    },
    handlePopShow(e) {
      this.savePreFocusElByEvent(e)
      this.isShowPop = true
      // 点击完赠品行后，重置初始化勾选的赠品数据标志位
      this.initFlag = false
      // 记录赠品行点击行为
      this.UPDATE_GIFT_OPT(1)
    },
    handleClose() {
      this.isShowPop = false
      // 更新用户最后一次主动选择行为下勾选的可选赠品，关闭弹窗就记录
      this.UPDATE_LAST_CHOOSED_GIFT_IDS()
      let arr = this.optionGifts.filter(v => v.canOptional == 1).map(v => v.optionalGiftId + v.id)
      // 更新当前skuId下勾选的可选赠品
      this.UPDATE_SELECTED_GIFT_IDS({
        skuId: this.skuId,
        ids: arr.length ? arr : []
      })
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss" />
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4,
.vivo-fontscale-5 {
  .giveaway-item {
    width: 178px;
  }
  .optional-gifts {
    height: 229px;
    .optional-item {
      width: 178px;
    }
  }
  .giveaway .g-list {
    .g-name {
      height: 38px;
    }
    .g-top {
      padding: 0 6px 3px;
    }
  }
}
</style>
